import { getUserBaseInfo } from "@/service/rapyd.service";
import DepositContext, { DepositContentProps } from "@/utils/depositContext";
import Script from "next/script";
import React, { useEffect, useState } from "react";
import RFLayout from "@/layout/RFLayout";
import Toast from "@/components/Toast";
import { RapydSupportContries } from "@/interfaces/rapydTypes";
import rfLocalStore from "@/utils/rfLocalStore";

interface DepositLayoutProps {
	children: React.ReactNode;
}

export default function DepositLayout({ children }: DepositLayoutProps) {
	const [depositInfo, setDepositInfo] = useState<DepositContentProps>();

	useEffect(() => {
		genDepositInfo();
	}, []);

	const genDepositInfo = async () => {
		try {
			let currency = "";
			let price = 0;

			const localStore = rfLocalStore.getDeposit();
			if (localStore) {
				if (localStore.price) {
					price = localStore.price;
				}
				if (localStore.currency) {
					currency = localStore.currency;
				}
			}

			if (!currency || !price) throw Error("Missing currency or price");

			// 接口获取
			const data = await getUserBaseInfo();
			if (!data) throw Error("Missing User Infos");

			const { masterAccountNameLocal, email, region } = data;

			// 币种是特殊国家-- 默认的region为币种对应的国家
			const includeCountry = RapydSupportContries.find((item) => item.currency === currency);

			setDepositInfo({
				currency,
				price,
				email,
				defaultRegion: includeCountry ? includeCountry.value : region,
				name: masterAccountNameLocal,
			});
		} catch (error: any) {
			Toast.fail(error.message);
		}
	};

	return (
		<RFLayout>
			<Script src="https://cdn.checkout.com/js/framesv2.min.js" async></Script>

			<DepositContext.Provider value={depositInfo}>{children}</DepositContext.Provider>
		</RFLayout>
	);
}
